export default "__VITE_ASSET__r3aHsgb7__"